import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Typography } from '@mui/material';
import styles from './styles.module.scss';
import {
  Box, Card, CardContent,
  TextField, InputAdornment, SvgIcon, Button,
  Grid
} from '@material-ui/core';
import SearchIcon from '@mui/icons-material/Search';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Loader from '@components/Loader';
import { useNavigate } from 'react-router-dom';
import { getApiReq, } from 'src/utils/ApiHandlers';
import { useDispatch } from 'react-redux';
import { showToast } from '@redux/action/index';
import { imageHandler } from 'src/utils/formatter';

export default function SuperHeroes() {
  const [isLoading, setIsLoading] = useState(false)
  const [search, setSearch] = useState('')
  const navigate = useNavigate();
  const [herosList, setHerosList] = useState([])
  const dispatch = useDispatch();

  const getHerosList = () => {
    setIsLoading(true);
    getApiReq(`/admin/get-heros-list?search=${search}`)
      .then(res => {
        if (res) {
          setHerosList(res.data)
          setIsLoading(false);
        }
        else {
          dispatch(showToast({ message: res.error, type: 'error' }))
          setIsLoading(false);
        }
      }).catch(e => { console.log(e) })
  };

  useEffect(() => {
    getHerosList();
  }, [search]);

  return (
    <React.Fragment>
      <TableContainer component={Paper} className={styles.tableContainer}>
        <Typography className={styles.heading}>SuperHero</Typography>
        <p className={styles.paragraph}>A series of games or contests that make up a single unit of competition.</p>
        <Box mt={3}>
          <Card>
            <CardContent>
              <Grid container spacing={3} alignItems='center'>
                <Grid item xs={8}>
                  <TextField
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SvgIcon
                            fontSize="small"
                            color="action"
                          >
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      )
                    }}
                    placeholder="Search"
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={4} align="right">
                  <Button onClick={() => navigate('/create-superheroes')} size="large" variant="contained" startIcon={<AddCircleIcon />}>Create SuperHero</Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Box>
     
        {/* <InfiniteScroll
          dataLength={length}
          next={getMoreList}
          hasMore={true}
          style={{ overflow: 'none' }}
        > */}

        <Table className='table' sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
            
              <TableCell className={styles.tabletitle}>#</TableCell>
              <TableCell className={styles.tabletitle} align="center">Asset Image</TableCell>
              <TableCell className={styles.tabletitle} align="center">Heros Name</TableCell>
              <TableCell className={styles.tabletitle} align="center">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {herosList?.map((item, index) => (
              <TableRow
                className={styles.tableRow}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell  >{index + 1}</TableCell>
                <TableCell className={styles.dataView} align="center" ><img className={styles.squireImg} src={imageHandler(item.profile,6)} alt='' /></TableCell>
                <TableCell className={styles.dataView} align="center" >{item.name}</TableCell>
                <TableCell className={styles.addPlayer} align="center" onClick={() => navigate(`/update-superheroes/${item._id}`)}>Update</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        {herosList?.length < 1 && <Box align={'center'} w='100%' p={5} >
          <Typography variant="body1" textAlign="center" color="textSecondary">Data not Available</Typography>
        </Box>}

        {/* </InfiniteScroll> */}
        <Loader isLoading={isLoading} />
      </TableContainer >

    </React.Fragment >
  );
}
